import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { isEmpty } from 'lodash';
import { Modal, Form } from 'antd';

import { useDefaultFormErrorNotification } from '@/hooks';

import ContactForm from './ContactForm';
import { ContactDefaultType, ContactModalProps } from './types';

function ContactModal({
  visible,
  onClose,
  onOk,
  loading,
  contact,
  simpleForm,
}: ContactModalProps) {
  const intl = useIntl();
  const [form] = Form.useForm<ContactDefaultType>();
  const { sendFormErrorNotification } = useDefaultFormErrorNotification();

  useEffect(() => {
    if (visible && contact && !isEmpty(contact)) {
      form.setFieldsValue(contact);
    }
  }, [contact]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();

      await onOk(values);

      handleCancel();
    } catch (err) {
      sendFormErrorNotification(err);
    }
  };

  const handleCancel = () => {
    form.resetFields();

    onClose();
  };

  return (
    <Modal
      title={intl.formatMessage({ id: 'commons.contact' })}
      visible={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={loading}
    >
      <ContactForm form={form} simpleForm={simpleForm} />
    </Modal>
  );
}

export default ContactModal;
